module.exports = __webpack_public_path__ + "img/TuanTruong.ce65a13b.jpeg";